import React, { useEffect, useState } from "react";


const adminService = {
  getAdminStats: async () =>
    new Promise((resolve) =>
      setTimeout(
        () =>
          resolve({
            data: {
              totalAdmins: 18,
              totalSubAdmins: 7,
              activeAdmins: 15,
              blockedAdmins: 3,
            },
          }),
        200
      )
    ),
};

const cuttingService = {
  getDashboardStats: async () =>
    new Promise((resolve) =>
      setTimeout(
        () =>
          resolve({
            data: { total: 48, approved: 21, pending: 15, rejected: 12 },
          }),
        180
      )
    ),
};

const trimmingService = {
  getDashboardStats: async () =>
    new Promise((resolve) =>
      setTimeout(
        () =>
          resolve({
            data: { total: 30, approved: 10, pending: 12, rejected: 8 },
          }),
        150
      )
    ),
};

const photoService = {
  getDashboardStats: async () =>
    new Promise((resolve) =>
      setTimeout(
        () =>
          resolve({
            data: { total: 18, approved: 9, pending: 6, rejected: 3 },
          }),
        150
      )
    ),
};

const gardenVisitService = {
  getDashboardStats: async () =>
    new Promise((resolve) =>
      setTimeout(
        () =>
          resolve({
            data: { total: 27, approved: 14, pending: 8, rejected: 5 },
          }),
        150
      )
    ),
};

const volunteerService = {
  getDashboardStats: async () =>
    new Promise((resolve) =>
      setTimeout(
        () =>
          resolve({
            data: { total: 16, approved: 7, pending: 6, rejected: 3 },
          }),
        150
      )
    ),
};

const StatBadge = ({ label, value, color }) => {
  const colorMap = {
    teal: "bg-teal-50 text-teal-700 border-teal-200",
    blue: "bg-blue-50 text-blue-700 border-blue-200",
    yellow: "bg-yellow-50 text-yellow-700 border-yellow-200",
    red: "bg-red-50 text-red-700 border-red-200",
    blue: "bg-blue-50 text-blue-700 border-blue-200",
    indigo: "bg-indigo-50 text-indigo-700 border-indigo-200",
    violet: "bg-violet-50 text-violet-700 border-violet-200",
    emerald: "bg-emerald-50 text-emerald-700 border-emerald-200",
  };

  return (
    <div
      className={`p-3 border rounded-xl flex justify-between items-center ${colorMap[color]}`}
    >
      <div className="text-sm font-medium">{label}</div>
      <div className="text-2xl font-bold">{value}</div>
    </div>
  );
};


const Dashboard = () => {
  const [activeTab, setActiveTab] = useState("admins");
  const [loading, setLoading] = useState(true);


  const [adminStats, setAdminStats] = useState({
    totalAdmins: 0,
    totalSubAdmins: 0,
    activeAdmins: 0,
    blockedAdmins: 0,
  });


  const [apps, setApps] = useState({
    cutting: {},
    trimming: {},
    photo: {},
    visit: {},
    volunteer: {},
  });


  const [selectedApp, setSelectedApp] = useState(null);

  useEffect(() => {
    loadDashboard();
  }, []);

  const loadDashboard = async () => {
    setLoading(true);

    const [admin, cut, trim, photo, visit, vol] = await Promise.all([
      adminService.getAdminStats(),
      cuttingService.getDashboardStats(),
      trimmingService.getDashboardStats(),
      photoService.getDashboardStats(),
      gardenVisitService.getDashboardStats(),
      volunteerService.getDashboardStats(),
    ]);

    setAdminStats(admin.data);

    setApps({
      cutting: cut.data,
      trimming: trim.data,
      photo: photo.data,
      visit: visit.data,
      volunteer: vol.data,
    });

    setLoading(false);
  };


  return (
    <div className="p-8 min-h-screen bg-gradient-to-br from-indigo-50 via-purple-50 to-blue-50">

      <div className="flex justify-between items-center mb-10">
        <div>
          <h1 className="text-3xl font-extrabold text-slate-800">
            Superadmin Dashboard
          </h1>
          <p className="text-slate-500 text-sm">Your system insights</p>
        </div>

        <div className="flex gap-3">
          <button
            onClick={() => setActiveTab("admins")}
            className={`px-5 py-2 rounded-lg font-semibold ${
              activeTab === "admins"
                ? "bg-indigo-600 text-white shadow-md"
                : "bg-white border border-slate-200 text-slate-700"
            }`}
          >
            Admins Overview
          </button>

          <button
            onClick={() => setActiveTab("apps")}
            className={`px-5 py-2 rounded-lg font-semibold ${
              activeTab === "apps"
                ? "bg-purple-600 text-white shadow-md"
                : "bg-white border border-slate-200 text-slate-700"
            }`}
          >
            Applications Overview
          </button>
        </div>
      </div>

      {loading ? (
        <div className="text-center py-20 text-slate-600 font-medium">
          Loading dashboard...
        </div>
      ) : (
        <>

        {activeTab === "admins" && (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

    {/* Total Admins */}
    <div className="p-8 rounded-3xl shadow-xl bg-gradient-to-br from-teal-50 to-emerald-100 border border-teal-300 hover:shadow-2xl transition cursor-pointer">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-2xl font-bold text-teal-800">Total Admins</h3>
        <span className="text-4xl">👨🏻‍💼</span>
      </div>
      <div className="text-6xl font-extrabold text-teal-900">{adminStats.totalAdmins}</div>
      <p className="text-sm text-teal-700 mt-3">
        All registered admins in the system.
      </p>
    </div>

    {/* Total Sub Admins */}
    <div className="p-8 rounded-3xl shadow-xl bg-gradient-to-br from-blue-50 to-indigo-100 border border-blue-300 hover:shadow-2xl transition cursor-pointer">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-2xl font-bold text-blue-800">Total Subadmins</h3>
        <span className="text-4xl">👨🏻‍💼</span>
      </div>
      <div className="text-6xl font-extrabold text-blue-900">{adminStats.totalSubAdmins}</div>
      <p className="text-sm text-blue-700 mt-3">
        Subadmins with limited access.
      </p>
    </div>

    {/* Active Accounts */}
    <div className="p-8 rounded-3xl shadow-xl bg-gradient-to-br from-blue-50 to-emerald-200 border border-blue-300 hover:shadow-2xl transition cursor-pointer">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-2xl font-bold text-blue-800">Active Accounts</h3>
        <span className="text-4xl">🟢</span>
      </div>
      <div className="text-6xl font-extrabold text-blue-900">{adminStats.activeAdmins}</div>
      <p className="text-sm text-blue-700 mt-3">
        Currently active and functioning admins.
      </p>
    </div>

    {/* Blocked Accounts */}
    <div className="p-8 rounded-3xl shadow-xl bg-gradient-to-br from-red-50 to-rose-100 border border-red-300 hover:shadow-2xl transition cursor-pointer">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-2xl font-bold text-red-800">Blocked Accounts</h3>
        <span className="text-4xl">⛔</span>
      </div>
      <div className="text-6xl font-extrabold text-red-900">{adminStats.blockedAdmins}</div>
      <p className="text-sm text-red-700 mt-3">
        Accounts restricted due to violations.
      </p>
    </div>

  </div>
)}


          {activeTab === "apps" && (
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              

              <div className="col-span-1 bg-white rounded-2xl shadow-lg p-6 border border-slate-200">
                <h2 className="text-xl font-semibold text-slate-800 mb-4">
                  All Applications
                </h2>

                <div className="flex flex-col gap-4">


                  <div
                    onClick={() => setSelectedApp({ type: "Cutting Applications", ...apps.cutting })}
                    className="cursor-pointer bg-gradient-to-r from-teal-50 to-emerald-50 border border-teal-200 rounded-xl p-4 hover:shadow-lg transition"
                  >
                    <div className="flex justify-between items-center">
                      <h3 className="text-lg font-semibold text-teal-700">
                        Cutting Applications
                      </h3>
                      <span className="text-xl font-bold text-teal-700">
                        {apps.cutting.total}
                      </span>
                    </div>
                  </div>


                  <div
                    onClick={() => setSelectedApp({ type: "Trimming Applications", ...apps.trimming })}
                    className="cursor-pointer bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-xl p-4 hover:shadow-lg transition"
                  >
                    <div className="flex justify-between items-center">
                      <h3 className="text-lg font-semibold text-blue-700">
                        Trimming Applications
                      </h3>
                      <span className="text-xl font-bold text-blue-700">
                        {apps.trimming.total}
                      </span>
                    </div>
                  </div>


                  <div
                    onClick={() => setSelectedApp({ type: "Photography / Videography", ...apps.photo })}
                    className="cursor-pointer bg-gradient-to-r from-indigo-50 to-purple-50 border border-indigo-200 rounded-xl p-4 hover:shadow-lg transition"
                  >
                    <div className="flex justify-between items-center">
                      <h3 className="text-lg font-semibold text-indigo-700">
                        Photography / Videography
                      </h3>
                      <span className="text-xl font-bold text-indigo-700">
                        {apps.photo.total}
                      </span>
                    </div>
                  </div>


                  <div
                    onClick={() => setSelectedApp({ type: "Garden Visit Applications", ...apps.visit })}
                    className="cursor-pointer bg-gradient-to-r from-violet-50 to-pink-50 border border-violet-200 rounded-xl p-4 hover:shadow-lg transition"
                  >
                    <div className="flex justify-between items-center">
                      <h3 className="text-lg font-semibold text-violet-700">
                        Garden Visit Applications
                      </h3>
                      <span className="text-xl font-bold text-violet-700">
                        {apps.visit.total}
                      </span>
                    </div>
                  </div>


                  <div
                    onClick={() => setSelectedApp({ type: "Volunteer Applications", ...apps.volunteer })}
                    className="cursor-pointer bg-gradient-to-r from-emerald-50 to-teal-50 border border-emerald-200 rounded-xl p-4 hover:shadow-lg transition"
                  >
                    <div className="flex justify-between items-center">
                      <h3 className="text-lg font-semibold text-emerald-700">
                        Volunteer Applications
                      </h3>
                      <span className="text-xl font-bold text-emerald-700">
                        {apps.volunteer.total}
                      </span>
                    </div>
                  </div>

                </div>
              </div>


              <div className="col-span-2 bg-white rounded-2xl shadow-lg p-8 border border-slate-200">
                {selectedApp ? (
                  <>
                    <h2 className="text-2xl font-extrabold text-slate-800">
                      {selectedApp.type}
                    </h2>
                    <p className="text-sm text-slate-500 mb-6">
                      Status breakdown
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">


                      <div className="text-center bg-blue-50 border border-blue-200 p-6 rounded-xl">
                        <div className="text-blue-700 text-sm font-medium">Approved</div>
                        <div className="text-4xl font-bold text-blue-700 mt-2">
                          {selectedApp.approved}
                        </div>
                      </div>


                      <div className="text-center bg-yellow-50 border border-yellow-200 p-6 rounded-xl">
                        <div className="text-yellow-700 text-sm font-medium">Pending</div>
                        <div className="text-4xl font-bold text-yellow-700 mt-2">
                          {selectedApp.pending}
                        </div>
                      </div>


                      <div className="text-center bg-red-50 border border-red-200 p-6 rounded-xl">
                        <div className="text-red-700 text-sm font-medium">Rejected</div>
                        <div className="text-4xl font-bold text-red-700 mt-2">
                          {selectedApp.rejected}
                        </div>
                      </div>

                    </div>
                  </>
                ) : (
                  <div className="text-center text-slate-500 py-20">
                    Click an application on the left to see details.
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Dashboard;
